// import React from 'react';
import {
  Platform,
} from 'react-native';

// import methodIosInApp from './ios';
// import methodAndroidInApp from './android';
import methodPaypal from './paypal';
// import methodVisa from './visa';

const methods = [];

switch (Platform.OS) {
  case 'ios':
    // methods.push(methodIosInApp);
    break;

  case 'android':
    // methods.push(methodAndroidInApp);
    break;

  case 'web':
    /* fall through */

  default:
    // methods.push(methodVisa);
}

// PayPal is always available
methods.push(methodPaypal);

export default methods;
